import visionAPI from 'dashboard/api/vision';
import { createSseStream } from 'dashboard/composables/sse/createSseStream';

// Transporte SSE do Vision: a pergunta vai por HTTP (POST que publica no NATS no
// Rails, com gate premium) e a resposta STREAMA do Rails via SSE — o Rails assina o
// JetStream INTERNO e faz o pipe; o NATS não vai pro browser. O reader SSE
// (fetch + auth por header + handshake) é compartilhado com o Playground
// (`createSseStream`). Mesma interface do mock/nats: query(payload, onEvent).

export const sseVisionTransport = {
  // query(payload, onEvent) → Promise<unsubscribe>
  async query(payload, onEvent) {
    // Abre o stream (e espera o `: ready`) ANTES de postar a pergunta — não perde
    // os primeiros eventos do turn (espelha o "subscribe before ask" do nats).
    const unsubscribe = await createSseStream(
      visionAPI.streamUrl(payload.session_id),
      onEvent
    );

    try {
      await visionAPI.query({
        session_id: payload.session_id,
        turn_id: payload.turn_id,
        query: payload.query,
        context: payload.context,
      });
    } catch (error) {
      unsubscribe();
      throw error;
    }

    return unsubscribe;
  },
};
